import React from 'react';
import { View } from 'react-native';

import Text from '@/components/Typography/Text';
import Reveal from '@/components/Landing/Reveal';
import { Section, useLanding } from '@/components/Landing/LandingKit';
import { fluid } from '@/components/Landing/landingTokens';
import { Card, IconTile, SectionIntro } from '@/components/Landing/MarketingKit';
import { DIFFERENTIATORS } from '@/constants/enterpriseContent';

/** The six reasons the engagement goes differently than the last one did. */
function EnterpriseWhy() {
  const { c, isXS, isCompact, width } = useLanding();

  return (
    <Section label="Why work with Gab AI">
      <SectionIntro
        kicker="Why Gab AI"
        lines={[['Built by people who'], ['run this in production.']]}
        lede="Every point below is something we do because we operate our own platform at scale — not a promise we made up for a proposal."
        ledeMax={600}
      />

      <Reveal delay={100}>
        <View
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: isXS ? 12 : 16,
            marginTop: fluid(width, 36, 56),
          }}
        >
          {DIFFERENTIATORS.map((item) => (
            <Card
              key={item.title}
              style={{
                flexGrow: 1,
                flexBasis: isCompact ? '100%' : '30%',
                minWidth: 0,
                gap: 16,
              }}
            >
              <IconTile name={item.icon} size={38} />
              <View>
                <Text weight="bold" style={{ color: c.ink, fontSize: 16.5, letterSpacing: -0.28 }}>
                  {item.title}
                </Text>
                <Text style={{ color: c.muted, fontSize: 14, lineHeight: 22, marginTop: 7 }}>
                  {item.copy}
                </Text>
              </View>
            </Card>
          ))}
        </View>
      </Reveal>
    </Section>
  );
}

export default React.memo(EnterpriseWhy);
